<template>
  <div class="content--error">
    <MyHeader />

    <header class="content-header d-lg-none">
      <h1>Idea board</h1>
      <router-link :to="{name: 'AddIdea'}" class="button-icon-simple"><i class="icon-plus"></i></router-link>
    </header>
    
    <div class="error-body">
      <div class="error-content">
        <h1>It’s not you - it’s us.</h1>
        <p>Something went wrong at our end. Sorry about that.</p>
        <p class="error-code">Error code: 500</p>
        <router-link :to="{name: 'Home'}" class="button-icon button--submit">Go home <i class="icon-arrow"></i></router-link>
      </div>
      <div class="error-image">
        <img src="../../assets/images/errors/Error-500.svg">
      </div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import MyFooter from '../../components/general/Footer'
export default {
  name: "InternalServerError",
  components: { MyHeader, MyFooter },
}
</script>

<style scoped>

</style>
